module.exports = __webpack_public_path__ + "static/media/icon_express.ec36395f.png";